import Repository from '@/repositories/marketing'
const resource = '/contacts'

export default {
    fetch (config, listId) {
        return Repository.get(`lists/${listId}${resource}.json`, config)
    },
    stat (contactId, type, config) {
        return Repository.get(`${resource}/${contactId}/${type}.json`, config)
    },
    engagement_stat (contactId, type, config) {
        return Repository.get(`${resource}/${contactId}/${type}.json`, config)
    },
    getRecentActivities (contactId, config) {
        return Repository.get(`${resource}/${contactId}/recent_activities.json`, config)
    },
    toggleSubscriptions (contactId, payload, config) {
        return Repository.post(`${resource}/${contactId}/toggle_subscriptions.json`, payload, config)
    },
    toggleStatus(id,config){
        return Repository.get(`${resource}/${id}/toggle_status.json`,config)
    },
    getSubscribedLists (contactId, config) {
        return Repository.get(`${resource}/${contactId}/lists.json`, config)
    },
    dnmStatus (contactId, config) {
        return Repository.get(`${resource}/${contactId}/in_dnm.json`, config)
    },
    updateDNMStatus (isDNM, data) {
        if (isDNM) {
            return Repository.delete('/general_unsubscribes.json', { data })
        } else {
            return Repository.post('/general_unsubscribes.json', data)
        }
    },
    getFieldsData (contactId) {
        return Repository.get(`${resource}/${contactId}/fields_data.json`)
    },
    setFields (contactId, data) {
        return Repository.post(`${resource}/${contactId}/set_fields.json`, data)
    },
    delete (contactId) {
        return Repository.post(`${resource}/${contactId}/pseudonymize_contact.json`)
    },
    deleteListsContact (listId,contactId) {
        return Repository.delete(`/lists/${listId}/${resource}/${contactId}.json`)
    },
    endJourney (journeyId, contactId) {
        return Repository.put(`/workflows/${journeyId}/stop/${contactId}`)
    },
    resetJourney (journeyId, contactId) {
        return Repository.put(`/workflows/${journeyId}/reset/${contactId}`)
    },
    getContactsTags (contactId) {
        return Repository.get(`${resource}/${contactId}/tags.json`)
    },
    filters (contact_id,config){
        return Repository.get(`${resource}/${contact_id}/filters.json`,config)
    },
    getAllTags (config){
        return Repository.get('/tags.json',config)
    }, 
    getAllLinkTags (config){
        return Repository.get('/all_tags.json',config)
    },
    updateTags (contact_id,data) {
        return Repository.put(`${resource}/${contact_id}/update_tags.json`,data)
    },
    getAllFields(config){
        /*** params added to fetch contact tags */
        return Repository.get(`/get_all_fields.json?include_contact_tags=true`, config)
    },
    getCustomFields(config){
        return Repository.get(`/custom_fields.json`, config)
    },
    newContactWithoutList(data){
        return Repository.post(`/contacts.json`, data)
    },
    newContactWithList(list_id,data){
        return Repository.post(`/lists/${list_id}/contacts.json`, data)
    },
    getSubscribedBrands (contactId, config) {
        return Repository.get(`${resource}/${contactId}/brands.json`, config)
    },
    toggleBrandSubscription (contactId,data) {
        return Repository.post(`${resource}/${contactId}/toggle_brands_subscriptions.json`, data)
    },
    getContactInfo(config){
        return Repository.get(`${resource}/get_contact.json`, config)
    },
    getVouchers (contactId, config) {
		return Repository.get(`/contacts/${contactId}/vouchers.json`, config)
	},
    fetchContactInfo(config, listId){
        return Repository.get(`lists/${listId}${resource}.json`, config)
    },
    getJourneyContacts(id,config) {
        return Repository.get(`journeys/${id}/journey_contacts.json`,config)
    },
    getAllContacts(config){
        return Repository.get(`${resource}/get_all_contacts.json`, config)
    },
    smsContactEngagingKeywords(contactId, payload = {}) {
        const endpoint = `${resource}/${contactId}/most_engaging_keywords.json`;
        return Repository.get(endpoint, payload);
    }
}
